import Link from "next/link";
import React, { useState } from "react";
import { hero_6_data } from "../../data/hero_6_data";
import Image from "next/image";

const Hero_6 = () => {
  const handleVideo = () => {
    var iframes = document.querySelectorAll("iframe");
    const elementsArray = Array.from(iframes);
    for (var i = 0; i < elementsArray.length; i++) {
      const src = elementsArray[i].src;
      if (src && src.includes("youtube.com")) {
        // Replace "autoplay=1" with "autoplay=0" to stop the video
        elementsArray[i].src = src.replace("autoplay=1", "autoplay=0");
      }
    }
  };
  const [videoModal, setvideoModal] = useState(false);
  const [youtubeUrl, setYoutubeUrl] = useState("");
  return (
    <>
      {/* <!-- Hero --> */}
      <section className="relative px-6 pb-8 py-24 pt-0">
        <div className="flex flex-col gap-5 lg:flex-row">
          <div className="w-full lg:w-1/3">
            <div className="grid grid-cols-2 grid-rows-2 gap-5">
              {hero_6_data.slice(0, 4).map((item) => {
                const { id, title, img, authorName } = item;
                const itemLink = img
                  .split("/")
                  .slice(-1)
                  .toString()
                  .replace("_square.jpg", "")
                  .replace(".gif", "");
                return (
                  <article key={id}>
                    <div className="relative overflow-hidden rounded-2.5xl bg-white dark:bg-jacarta-700">
                      <figure className="relative">
                        {/* <Link
                          href={`/item/${itemLink}`}
                          className="group block after:absolute after:inset-0 after:block after:bg-jacarta-900/20"
                        > */}
                        <button
                           onClick={() => {setYoutubeUrl(item.url);setvideoModal(true);}}
                          className="js-video-modal-trigger  absolute top-1/2 left-1/2 flex h-16 w-16 -translate-y-1/2 -translate-x-1/2 items-center justify-center rounded-full border-2 border-white transition-transform will-change-transform hover:scale-90 z-[1]"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            className="h-8 w-8 fill-white"
                          >
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M19.376 12.416L8.777 19.482A.5.5 0 0 1 8 19.066V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832z" />
                          </svg>
                        </button>
                        <Image
                          width={470}
                          height={470}
                          src={img}
                          alt={title}
                          className="w-full object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105"
                        />
                        {/* </Link> */}
                      </figure>
                      <div className="pointer-events-none absolute bottom-0 w-full p-5 bg-[#0d102dc4] leading-[1px]">
                        <h2 className="font-display text-base leading-none text-white xl:text-lg">
                          {title}
                        </h2>
                        <span className="text-2xs text-white">
                          {authorName}
                        </span>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
          </div>
          <div className="w-full lg:w-1/3">
            {hero_6_data.slice(4, -4).map((item) => {
              const { id, title, img, authorName } = item;
              const itemLink = img
                .split("/")
                .slice(-1)
                .toString()
                .replace(".jpg", "")
                .replace("_square", "")
                .replace(".gif", "");
              return (
                <article key={id}>
                  <div className="relative overflow-hidden rounded-2.5xl bg-white dark:bg-jacarta-700">
                    <figure className="relative">
                      {/* <Link
                        href={`/item/${itemLink}`}
                        className="group block after:absolute after:inset-0 after:block after:bg-jacarta-900/20"
                      > */}
                      <button
                        onClick={() => {setYoutubeUrl(item.url);setvideoModal(true);}}
                        className="bg-[#0d102dc4] js-video-modal-trigger absolute  top-1/2 left-1/2 flex h-16 w-16 -translate-y-1/2 -translate-x-1/2 items-center justify-center rounded-full border-2 border-white transition-transform will-change-transform hover:scale-90 z-[1]"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                          className="h-8 w-8 fill-white"
                        >
                          <path fill="none" d="M0 0h24v24H0z" />
                          <path d="M19.376 12.416L8.777 19.482A.5.5 0 0 1 8 19.066V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832z" />
                        </svg>
                      </button>
                      <Image
                        width={470}
                        height={470}
                        src={img}
                        alt={title}
                        className="w-full object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105"
                      />
                      {/* </Link> */}
                    </figure>
                    <div className="pointer-events-none absolute bottom-0 w-full p-5 bg-[#0d102dc4] leading-[1px]">
                      <h2 className="font-display text-base leading-none text-white xl:text-lg">
                        {title}
                      </h2>
                      <span className="text-2xs text-white">{authorName}</span>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
          <div className="w-full lg:w-1/3">
            <div className="grid grid-cols-2 grid-rows-2 gap-5">
              {hero_6_data.slice(5, 9).map((item) => {
                const { id, title, img, authorName } = item;
                const itemLink = img
                  .split("/")
                  .slice(-1)
                  .toString()
                  .replace(".jpg", "")
                  .replace("_square", "")
                  .replace(".gif", "");
                return (
                  <article key={id}>
                    <div className="relative overflow-hidden rounded-2.5xl bg-white dark:bg-jacarta-700">
                      <figure className="relative">
                        {/* <Link
                          href={`/item/${itemLink}`}
                          className="group block after:absolute after:inset-0 after:block after:bg-jacarta-900/20"
                        > */}
                        <button
                           onClick={() => {setYoutubeUrl(item.url);setvideoModal(true);}}
                          className="js-video-modal-trigger absolute top-1/2 left-1/2 flex h-16 w-16 -translate-y-1/2 -translate-x-1/2 items-center justify-center rounded-full border-2 border-white transition-transform will-change-transform hover:scale-90 z-[1]"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            className="h-8 w-8 fill-white"
                          >
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M19.376 12.416L8.777 19.482A.5.5 0 0 1 8 19.066V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832z" />
                          </svg>
                        </button>
                        <Image
                          width={470}
                          height={470}
                          src={img}
                          alt={title}
                          className="w-full object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105"
                        />
                        {/* </Link> */}
                      </figure>
                      <div className="pointer-events-none absolute bottom-0 w-full p-5 bg-[#0d102dc4] leading-[1px]">
                        <h2 className="font-display text-base leading-none text-white xl:text-lg">
                          {title}
                        </h2>
                        <span className="text-2xs text-white">
                          {authorName}
                        </span>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
            {/* <!-- YouTube Video Modal --> */}
            <div
              className={
                videoModal
                  ? "modal lightbox fade show block"
                  : "modal lightbox fade"
              }
            >
              <div className="modal-dialog modal-dialog-centered modal-xl w-full">
                <div className="modal-content border-0 bg-transparent">
                  <div className="modal-body p-0 relative">
                    <button
                      onClick={() => (handleVideo(), setvideoModal(false))}
                      type="button"
                      className="btn-close position-absolute top-0 end-0 p-3 z-10"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                        fill="#fff"
                        className="h-6 w-6"
                      >
                        <path d="M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z"></path>
                      </svg>
                    </button>
                    <div
                      id="lightboxCarousel-d7ewe4ig"
                      className="lightbox-carousel carousel"
                    >
                      <div className="carousel-inner">
                        <div className="carousel-item active">
                          <div className="position-absolute top-50 start-50 translate-middle text-white">
                            <div className="spinner-border" role="status"></div>
                          </div>
                          <div className="ratio ratio-16x9">
                            <iframe
                              id="video"
                              src={youtubeUrl}
                              title="About Impactoverse"
                              allow="accelerometer clipboard-write encrypted-media gyroscope picture-in-picture autoplay"
                            ></iframe>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- end hero --> */}
    </>
  );
};

export default Hero_6;
